import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const resetPasswordValidationSchema = Yup.object().shape({
  newPassword: Yup.string().nullable(),
  confirmNewPassword: Yup.string()
    .nullable()
    .when("newPassword", (newPassword, schema) => {
      return newPassword
        ? schema.oneOf(
            [Yup.ref("newPassword")],
            SystemMessage.CONFIRM_PASSWORD_MISMATCH
          )
        : schema.notRequired();
    }),
});
